import { FulfillmentPositionDisplayMode, FulfillmentProductionState } from "@/data/model/Enums";
import type { IOperatorFulfillment } from "@/data/model/Operator";
import { DateTime } from "@/data/util/DateTime";

import { Component } from "@/shared/elements/Component";

import { FulfillmentHelper } from "@/operator/data/FulfillmentHelper";

export class FulfillmentQueueIndicator extends Component {
    private $timer!: JQuery;
    private $time!: JQuery;

    private colorsMap!: object;
    private currentProductionState?: FulfillmentProductionState;

    constructor(fulfillment?: IOperatorFulfillment) {
        super();
        this.initColorsMap();
        this.$element = this.drawElement();

        if (fulfillment != null) {
            this.updateQueueIndicator(new Date(), fulfillment);
        }
    }

    public updateQueueIndicator(currentDate: Date, fulfillment: IOperatorFulfillment) {
        // get new production state
        const newProductionState = FulfillmentHelper.getFulfillmentProductionState(fulfillment);

        // if state has changed
        if (this.currentProductionState != newProductionState) {
            // change current state
            this.currentProductionState = newProductionState;

            // set new color
            const newColor = this.colorsMap[newProductionState];
            this.$timer.removeClass("green red orange").addClass(newColor);

            // set late icon
            if (!this.isInPreparation()) {
                // add late icon
                if (this.$timer.find("> .lateicon").length === 0) {
                    this.$timer.append('<div class="lateicon"><i class="fal fa-history"></i></div>');
                }
            } else {
                // remove late icon
                this.$timer.find("> .lateicon").remove();
            }
        }

        // display queue position/time value
        if (this.shouldDisplayQueuePosition(fulfillment)) {
            const positionToDisplay =
                (fulfillment.currentQueuePosition ?? 0) < 100
                    ? `${fulfillment.currentQueuePosition}`
                    : '99<span class="unit">+</span>';
            this.$time.html(positionToDisplay);
        } else {
            this.$time.html(`${this.getTimeToReadyDate(currentDate, fulfillment.amendedReadyDateTime)}`);
        }
    }

    private shouldDisplayQueuePosition(fulfillment: IOperatorFulfillment) {
        return (
            fulfillment.fulfillmentPositionDisplayMode == FulfillmentPositionDisplayMode.Position &&
            this.isInPreparation()
        );
    }

    private getTimeToReadyDate(currentDate: Date, readyDate: Date) {
        const timeDif = FulfillmentHelper.getTimeLeftToDate(readyDate, currentDate);
        const displayValue = DateTime.secondsToFulfillmentTimeStr(timeDif);
        return displayValue;
    }

    private isInPreparation() {
        return (
            this.currentProductionState == FulfillmentProductionState.InPreparation ||
            this.currentProductionState == FulfillmentProductionState.ReadyShortly
        );
    }

    protected drawElement(): JQuery {
        this.$timer = $('<div class="timer" />');
        this.$time = $('<div class="time" />').appendTo(this.$timer);

        return this.$timer;
    }

    private initColorsMap() {
        this.colorsMap = {};
        this.colorsMap[FulfillmentProductionState.InPreparation] = "green";
        this.colorsMap[FulfillmentProductionState.ReadyShortly] = "orange";
        this.colorsMap[FulfillmentProductionState.Ready] = "red";
        this.colorsMap[FulfillmentProductionState.FulfilledNotPaid] = "red";
    }
}
